<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-row p-4">
		<div class="vx-col w-full">
			<ul class="ul-area">
				<li class="mt-3">
					<vs-radio v-model="status" vs-value="frequencyDayMonth">{{ $t("TimeWindow.EveryDay") }}</vs-radio>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="rangeDayMonth">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.Every") }} </span>
									<vs-select
										autocomplete
										v-model="everyNumber"
										width="60px"
										class="ml-1"
										:disabled="status !== 'rangeDayMonth'"
										:input-changed="getResultDayMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in dayMonthList"
										/>
									</vs-select>
									<span class="ml-1"
										>{{ ($t("TimeWindow.Day") + " ") | lowerCase
										}}{{
											($t("TimeWindow.FromThe") + " " + $t("TimeWindow.Day")) | lowerCase
										}}</span
									>
									<vs-select
										autocomplete
										v-model="numberDayMonth"
										width="60px"
										class="ml-1"
										:disabled="status !== 'rangeDayMonth'"
										:input-changed="getResultDayMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in dayMonthList"
										/>
									</vs-select>
									<span class="ml-1">{{ ($t("TimeWindow.OfTheMonth") + " ") | lowerCase }}</span>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="choiceDayMonth">{{
								$t("TimeWindow.SpecificDayOfTheMonth")
							}}</vs-radio>
							<vs-select
								autocomplete
								multiple
								v-model="selectDayMonth"
								width="100%"
								:disabled="status !== 'choiceDayMonth'"
								:input-changed="getResultDayMonth"
								@input="selectDayMonth.sort()"
							>
								<vs-select-item
									:key="index"
									:value="option.value"
									:text="option.text"
									v-for="(option, index) in dayMonthList"
								/>
							</vs-select>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="betweenDayMonth">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.EveryDayBetween") }} </span>
									<vs-select
										autocomplete
										v-model="numbeRangeInit"
										width="120px"
										class="ml-1"
										:disabled="status !== 'betweenDayMonth'"
										:input-changed="getResultDayMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in dayMonthList"
										/>
									</vs-select>
									<span class="ml-1">{{ ($t("TimeWindow.And") + " ") | lowerCase }}</span>
									<vs-select
										autocomplete
										v-model="numbeRangeEnd"
										width="120px"
										class="ml-1"
										:disabled="status !== 'betweenDayMonth'"
										:input-changed="getResultDayMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in dayMonthList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "DayMonth",
	data() {
		return {
			status: "frequencyDayMonth",
			everyNumber: 1,
			numberDayMonth: 1,
			numberDay: 1,
			numbeRangeInit: 1,
			numbeRangeEnd: 1,
			selectDayMonth: [1],
		};
	},
	props: {
		cronExpressionDayMonth: {
			type: String,
			default: "",
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		getResultDayMonth() {
			let result = "";
			switch (this.status) {
				case "frequencyDayMonth":
					result = "*";
					break;
				case "rangeDayMonth":
					result = `${this.numberDayMonth}/${this.everyNumber}`;
					break;
				case "choiceDayMonth":
					result = this.selectDayMonth ? `${this.selectDayMonth.join(",")}` : "";
					break;
				case "betweenDayMonth":
					result = `${this.numbeRangeInit}-${this.numbeRangeEnd}`;
					break;
			}
			this.$emit("resultDayMonthEmit", result);
			return result;
		},
		dayMonthList() {
			let dayMonth = [];
			for (let i = 1; i <= 31; i++) {
				dayMonth.push({text: i.toString(), value: i});
			}
			return dayMonth;
		},
	},
	mounted() {
		if (
			this.cronExpressionDayMonth !== " " &&
			this.cronExpressionDayMonth !== null &&
			this.cronExpressionDayMonth !== undefined &&
			this.isEdit
		) {
			if (this.cronExpressionDayMonth.includes("*")) {
				this.status = "frequencyDayMonth";
			} else if (this.cronExpressionDayMonth.includes("/")) {
				this.numberDayMonth = this.cronExpressionDayMonth.split("/")[0];
				this.everyNumber = this.cronExpressionDayMonth.split("/")[1];
				this.status = "rangeDayMonth";
			} else if (this.cronExpressionDayMonth.includes("-")) {
				this.numbeRangeInit = this.cronExpressionDayMonth.split("-")[0];
				this.numbeRangeEnd = this.cronExpressionDayMonth.split("-")[1];
				this.status = "betweenDayMonth";
			} else {
				if (this.cronExpressionDayMonth.includes(",")) {
					this.selectDayMonth = this.cronExpressionDayMonth.split(",").map((dayMonth) => parseInt(dayMonth));
				} else {
					this.selectDayMonth = [parseInt(this.cronExpressionDayMonth)];
				}
				this.status = "choiceDayMonth";
			}
		}
	},
};
</script>
<style lang="scss">
.form-inline {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-flow: row wrap;
	flex-flow: row wrap;
	-ms-flex-align: center;
	align-items: center;
}
.specific-check {
	display: flex;
	flex-wrap: wrap;
	padding-left: 20px;
}
.check-week {
	padding: 10px 0px 10px 0px;
}
.vs-radio--input + .vs-radio + .vs-radio--label {
	color: #ababab;
	cursor: pointer;
}
.vs-radio--input:checked + .vs-radio + .vs-radio--label {
	color: #000;
}
</style>
